import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import styles from './ProductImagesSlider.module.scss';
import useInterval from '../../../hooks/useInterval';
import useWindowWidth from '../../../hooks/useWindowWidth';

const SLIDER_DELAY = 1000;
const FIRST_POSITION = 0;

function ProductImagesSlider(props) {
  const { images = 0, cardRef } = props;

  const container = useRef(null);
  const [currentImage, setCurrentImage] = useState(FIRST_POSITION);
  const [delay, setDelay] = useState(null);
  const [width, setWidth] = useState(props.width);

  const windowWidth = useWindowWidth();

  useInterval(() => {
    setCurrentImage((current) => nextSliderPosition(current));
  }, delay);

  useEffect(() => {
    if (cardRef && cardRef.current) {
      setWidth(cardRef.current.offsetWidth);
    }
  }, [cardRef, windowWidth]);

  useEffect(() => {
    container.current.style.left = -1 * currentImage * width + 'px';
  }, [currentImage, width]);

  const nextSliderPosition = (current) => {
    const isLastPosition = current === images.length - 1;
    return isLastPosition ? FIRST_POSITION : current + 1;
  };

  const startSlider = () => {
    setDelay(SLIDER_DELAY);
  };

  const stopSlider = () => {
    setDelay(null);
    setCurrentImage(FIRST_POSITION);
  };

  return (
    <div
      ref={container}
      className={styles.main_container}
      style={{ width: width * images.length + 'px' }}
      onMouseEnter={startSlider}
      onMouseLeave={stopSlider}
    >
      {images.map((img, i) => (
        <div style={{ width: width + 'px' }} key={i}>
          <img alt="" src={img} style={{ maxHeight: width + 'px' }} />
        </div>
      ))}
    </div>
  );
}

export default ProductImagesSlider;

ProductImagesSlider.propTypes = {
  images: PropTypes.array.isRequired,
  width: PropTypes.number,
};
